import { Dispatch, GetState } from '../../../types'
import { goToBuiltIn } from '../../Sidebar/Urls'
import { getResourceId, getResourceMuleVersion, getResourceType, isTarget, ResourceType } from '../../../common/resource/model'
import { getDashboardType } from '../dashboardType'
import { selectors as authSelectors } from '../../../lifecycle/auth'
import MonitoringLocalStorageManager from '../../../util/storage/MonitoringLocalStorageManager'
import { setBuiltInStateFromLandingPageAction } from '../actions'
import { fetchMainSelectorsOptionsAndSelect } from '../../../common/selector/actions'
import { builtInLPOrigin, builtInOrigin } from '../model'
import { isPCEOrGov } from '../../../util/environments'
import { fetchFeaturesCompatibility } from '../../../common/compatibility/actions'
import { isFlex } from '../../../util/flex';
import FeatureFlagService from '../../../services/FeatureFlagService';
import FeatureFlags from '../../../types/featureflags';

// Thunks

export const checkBuiltInDashboardsState = () => (dispatch: Dispatch, getState: GetState) => {
  const builtInPageState = getState().monitoring.builtIn
  const options = {origin: builtInLPOrigin, lsOrigin: builtInOrigin, withMetrics: true}
  const environmentSelector = builtInPageState.environmentSelector
  const resourceSelector = builtInPageState.resourceSelector
  const versionSelector = builtInPageState.versionSelector

  const environment = environmentSelector.selected
  const resource = resourceSelector.selected
  const version = versionSelector.selected

  const isTitanium = authSelectors.isMonitoringCenterPremium(getState())
  const lsBuiltIn = MonitoringLocalStorageManager.get('builtIn')

  if (environment && resource) {
    const resourceType = getResourceType(resource)
    const muleVersion = getResourceMuleVersion(resource)
    const dashboardType = lsBuiltIn.dashboardType === null ? undefined : lsBuiltIn.dashboardType
    const featuresCompatibility = getState().monitoring.featuresCompatibility.resources
    const apiMetricsCompatible = featuresCompatibility ? featuresCompatibility.apiMetrics.compatible : false

    const resolvedDashboardType = getDashboardType(isTitanium, resourceType, dashboardType, muleVersion, (isPCEOrGov() || isFlex(resource)) ? true : apiMetricsCompatible)

    goToBuiltIn(environment.id, resolvedDashboardType, resource, version ? version.id.toString() : undefined)
  } else {
    const skipFetchingResources = FeatureFlagService.get(FeatureFlags.BUILT_IN_DASHBOARDS_SKIP_LOADING_RESOURCES_ENABLED);
    // This is the initial render of the built-in dashboard landing page. If the feature flag is enabled,
    // ensure that resources are NOT automatically fetched, wait for user selection of environment to fetch apps/apis resources
    dispatch(fetchMainSelectorsOptionsAndSelect(options, undefined, undefined, undefined, skipFetchingResources))
  }
}

export const viewBuiltInDashboards = (orgId: string, environmentId: string, resourceId: string, versionId?: string) =>
  (dispatch: Dispatch, getState: GetState) => {
    const landingPageState = getState().monitoring.builtIn.landingPage
    const resourceSelector = landingPageState.resourceSelector
    const resource = resourceSelector.selected
    const isTitanium = authSelectors.isMonitoringCenterPremium(getState())
    const lsBuiltIn = MonitoringLocalStorageManager.get('builtIn')

    if (resource && getResourceId(resource) === resourceId) {
      const resourceType = getResourceType(resource)
      const muleVersion = getResourceMuleVersion(resource)
      const dashboardType = lsBuiltIn.dashboardType === null ? undefined : lsBuiltIn.dashboardType
      const resId = resourceType === ResourceType.API ? `${resourceId}:${versionId}` : getResourceId(resource)

      if (isTarget(resource)) {
        const resolvedDashboardType = getDashboardType(isTitanium, resourceType, dashboardType, muleVersion, false)
        dispatch(setBuiltInStateFromLandingPageAction(landingPageState.environmentSelector, resourceSelector, landingPageState.versionSelector))
        goToBuiltIn(environmentId, resolvedDashboardType, resource, versionId)
      } else {
        dispatch(fetchFeaturesCompatibility(orgId, environmentId, resourceType, resId, 'monitoring')).then(() => {
          const featuresCompatibility = getState().monitoring.featuresCompatibility.resources
          const apiMetricsCompatible = featuresCompatibility ? featuresCompatibility.apiMetrics.compatible : false

          const resolvedDashboardType =
              getDashboardType(isTitanium, resourceType, dashboardType, muleVersion, (isPCEOrGov() || isFlex(resource)) ? true : apiMetricsCompatible)
          dispatch(setBuiltInStateFromLandingPageAction(landingPageState.environmentSelector, resourceSelector, landingPageState.versionSelector))
          goToBuiltIn(environmentId, resolvedDashboardType, resource, versionId)
        }).catch(() => {
          const resolvedDashboardType = getDashboardType(isTitanium, resourceType, dashboardType, muleVersion, isPCEOrGov() || isFlex(resource))
          dispatch(setBuiltInStateFromLandingPageAction(landingPageState.environmentSelector, resourceSelector, landingPageState.versionSelector))
          goToBuiltIn(environmentId, resolvedDashboardType, resource, versionId)
        })
      }
    }
  }
